// DELINQUENT-SAME-PAYEE-FLICKER-001 — animates height changes of swapped content (presentation only).
import React, { useLayoutEffect, useRef, useState } from 'react';

const MS = 200;

export const AnimatedHeight = ({ children, className = '', testId }) => {
  const innerRef = useRef(null);
  const [height, setHeight] = useState(null);
  const [animating, setAnimating] = useState(false);
  const timer = useRef(null);
  const last = useRef(null);

  useLayoutEffect(() => {
    const el = innerRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const apply = () => {
      const h = el.offsetHeight;
      if (last.current != null && h !== last.current) {
        setAnimating(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setAnimating(false), MS + 20);
      }
      last.current = h;
      setHeight(h);
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => { ro.disconnect(); clearTimeout(timer.current); };
  }, []);

  return (
    <div
      className={`tcp-ah ${animating ? 'is-animating' : ''} ${className}`}
      style={{ height: height == null ? 'auto' : height }}
      data-testid={testId}
    >
      <div ref={innerRef}>{children}</div>
    </div>
  );
};

export default AnimatedHeight;
